const SNIPPET3 = [
  {
    title: 'Space Harrier/Outrun motor board',
    data: 'Forum members NaokiS and John Bennett share some awesome info on their work so far...',
    readit: '',
    url: 'http://www.ukvac.com/forum/space-harrier-outrun-dx-motor-openboard-project_topic363717.html',
    imgurl: 'http://www.ukvac.com/forum/uploads/573/Driveboardstripped.jpg',
    objectID: 0
  }
];

export default SNIPPET3;


// WEBPACK FOOTER //
// ./src/data-forumsnippet3.js